// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__37-I1","range":"MonthRangeSwitch_range__3AbbT","disabled":"MonthRangeSwitch_disabled__2ENTZ"};